// src/components/PushMessageHandler.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useIntercomStore from '../stores/intercomStore';

export default function PushMessageHandler() {
  const navigate = useNavigate();
  const addNotification = useIntercomStore((state) => state.addNotification);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // Listen for messages from service worker
    const handleMessage = (event) => {
      console.log('[PushHandler] Received message from SW:', event.data);
      
      if (event.data?.type === 'PUSH_NOTIFICATION_CLICK') {
        const { action, data } = event.data;
        
        if (data.type === 'intercom') {
          // Add to store so toast appears
          if (addNotification) {
            addNotification({
              id: data.notificationId || `push-${Date.now()}`,
              intercomId: data.intercomId,
              intercomName: data.intercomName,
              cameraId: data.cameraId,
              timestamp: data.timestamp || new Date().toISOString(),
              fromPush: true
            });
          }
          
          // Navigate to intercoms page
          navigate('/intercoms');
        } else if (data.url) {
          navigate(data.url);
        }
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, [navigate, addNotification]);

  return null; // This component doesn't render anything
}
